import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);
dayjs.extend(isoWeek);

const pstTimezone = 'America/Los_Angeles';

const getNextWeekday = (options: {
  targetWeekday: number;
  timezone?: string;
}): dayjs.Dayjs => {
  const { targetWeekday, timezone } = options;
  const now = dayjs().tz(timezone).startOf('hour');
  const currentWeekday = dayjs().tz(timezone).isoWeekday();

  if (currentWeekday < targetWeekday) {
    return now.clone().tz(timezone).isoWeekday(targetWeekday);
  } else {
    return now.clone().tz(timezone).add(1, 'week').isoWeekday(targetWeekday);
  }
};

export const useDefaultScheduledPostOptions = (): {
  label: string;
  date: dayjs.Dayjs;
}[] => {
  /** The upcoming Wednesday at 9PM PST */
  const beforeNextWeeklyDigest = (() => {
    const upcomingWednesday = getNextWeekday({
      targetWeekday: 3,
      timezone: pstTimezone,
    });

    return upcomingWednesday.set('hour', 21).local();
  })();

  const tomorrowMorning9AMLocalTime = dayjs()
    .startOf('hour')
    .add(1, 'day')
    .set('hour', 9);

  const upcomingMonday9AMLocalTime = (() => {
    const upcomingMonday = getNextWeekday({ targetWeekday: 1 });
    return upcomingMonday.set('hour', 9);
  })();

  return [
    { label: 'Before the Next Weekly Digest', date: beforeNextWeeklyDigest },
    { label: 'Tomorrow Morning', date: tomorrowMorning9AMLocalTime },
    { label: 'Monday Morning', date: upcomingMonday9AMLocalTime },
  ];
};
